import React from "react";

export const SetLoadingContext = React.createContext<React.Dispatch<React.SetStateAction<boolean>> | undefined>(
  undefined
);

export default SetLoadingContext;
